<div class="page-wrapper relative bg-app-background">
    <div class="h-[200px] flex-none bg-brand-header" aria-hidden="true"></div>
    <mat-card
        class="absolute left-1/2 top-[130px] box-border w-[calc(100%_-_32px)] max-w-[600px] -translate-x-1/2 !p-0"
        appearance="outlined"
    >
        <mat-card-content class="p-8 text-center text-[#333]/[0.675] min-[632px]:p-12">
            <img class="mx-auto mb-5 block w-[125px] max-w-full" src="logo-dark.svg" [alt]="Strings.brandName" />
            <div class="mb-[30px] text-xl font-normal text-brand-primary">{{ Strings.appLongName }}</div>
            <div class="mx-auto max-w-[350px]">
                <h1 id="role-assignment-required-title" class="mx-0 mt-0 mb-5 text-lg font-normal">
                    Access restricted
                </h1>
                <p class="mb-5">
                    <span class="block">You have not been assigned a role</span>
                    <span class="block">Contact your organisation administrator</span>
                </p>
                <button class="w-full" mat-flat-button color="primary" type="button" (click)="logout()">Log out</button>
            </div>
        </mat-card-content>
    </mat-card>
</div>
